<div class="text-center">
  <mat-icon>developer_board</mat-icon>
  <h1 mat-dialog-title>Stato Dispositivi</h1>

  <div class="modal-body" mat-dialog-content>
    <help-alert
      text="help.page.slot_model.model_field"
      info="help.info"
      description="help.page.slot_model.model_description"
    ></help-alert>

    <div class="card mt-3"><b>Ultimo controllo: </b>{{lastRefresh}}</div>

    <div class="container mt-3">
      <div
        class="card mb-2 p-2"
        style="display: flex; flex-direction: row; align-items: center"
        *ngFor="let device of list"
      >
        <span
          class="dot p-2"
          [style.background-color]="checkStatus(device.lastCheck)"
        ></span>
        <div class="font-weight-bold p-2">{{device.deviceName}}</div>
        <div
          class="p-2"
          style="display: flex; flex-direction: column; align-items: flex-start"
        >
          <div>Ultimo check: {{device.lastCheck}}</div>
          <div>
            Ultimo Log: {{device.tsInsert}}
            <span *ngIf="device.action && device.details"
              >( {{device.action}} : {{device.details}} )</span
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal-footer"
      style="margin-bottom: 0; display: flex; justify-content: space-between"
      mat-dialog-actions
    >
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="refresh()"
      >
        Ricarica ({{timeLeft}})
      </button>
      <button type="button" class="btn btn-outline-danger" (click)="cancel()">
        Chiudi
      </button>
    </div>
  </div>
</div>
